import React, { memo } from 'react';
import FormikWrapper from '../FormikWrapper';
import InternalSwitch from './InternalSwitch';
import type { useFormikContext } from 'formik';
import type { InputFieldFactoryProps, InputFactoryOnChangeFunc } from '../Factory/InputFieldFactory';

export type SwitchProps = Pick<InputFieldFactoryProps, 'className' | 'field' | 'hideErrorText'> & {
  onChange?: InputFactoryOnChangeFunc;
  variant?: 'default' | 'slim' | string;
  testId?: string;
};

const Switch = (props: SwitchProps) => {
  return (
    <FormikWrapper>
      {(formik: ReturnType<typeof useFormikContext>) => <InternalSwitch formik={formik} {...props} />}
    </FormikWrapper>
  );
};

export default memo(Switch);
